import type { ReactElement } from 'react';

import { ensureDefined } from '@e-socna/utils';
import { RESOLVER_CONTENT_CLASSNAME } from '@e-socna/printer-contract';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useQuotationContact } from './hooks/useQuotationContact.hook';

export const useDevisPolitesseIntro = (
  parameters: ResolverParameters,
): ResolverResult<ReactElement> => {
  const recipient = useQuotationContact(parameters);

  if (!recipient.isSuccess) {
    return {
      ...recipient,
      data: undefined,
    };
  }

  const {
    data: { civility },
  } = ensureDefined({
    data: recipient.data,
  });

  const content = (
    <div className={RESOLVER_CONTENT_CLASSNAME}>
      <p>{civility.label},</p>
      <p>
        En réponse à votre demande adressée à nos services, nous avons le
        plaisir de vous communiquer notre meilleure offre relative à
        l&apos;opération visée ci-dessous
      </p>
    </div>
  );

  return {
    data: { generated: content },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
